import { Icon } from 'gu-ui-kit'
import React from 'react'

export default () => {
  return {
    initial: {
      query: '',
      is_archived: false,
      statuses: [],
    },
    configuration: {
      query: {
        subbutton: { isVisible: (value = '') => !!value },
        label: 'services::account_list.filter_controls.filter_input.label',
        placeholder: 'services::account_list.filter_controls.filter_input.placeholder',
        order: 1,
        type: 'input',
      },
      is_archived: {
        subbutton: {
          isVisible: (value = null, breakpoints) => value !== null || !breakpoints.fb,
        },
        icon: (
          <Icon
            name={'checkmark2'}
            size={'s'}
            bgColor={'Accent-Notice-Primary'}
            color={'Label-Onsurface'}
          />
        ),
        label: 'services::account_list.archive.label',
        position: 'dropdown',
        type: 'radio group',
        optionLabelPrefix: 'services::account_list.archive.options.',
        options: [true, false],
      },
      statuses: {
        subbutton: {
          isVisible: (value = [], breakpoints) => value.length > 0 || !breakpoints.fb,
        },
        icon: (
          <Icon
            name={'avatar1'}
            size={'s'}
            bgColor={'Accent-Confirm-Secondary'}
            color={'Label-Onsurface'}
          />
        ),
        label: 'services::account_list.statuses_label',
        position: 'dropdown',
        type: 'checkbox group',
        optionLabelPrefix: 'services::account_list.statuses.',
        options: ['new', 'pending', 'verified', 'declined', 'block', 'deleted', 'error'],
      },
    },
  }
}
